<template>
  <div class="signed-list-page" v-loading="loading">
    <div class="page-header">
      <div class="tab">已签约</div>
    </div>

    <!-- 筛选区域 -->
    <div class="filter-section">
      <div class="filter-form">
        <div class="filter-item">
          <span class="filter-label">医生姓名</span>
          <el-input
            v-model="searchForm.queryStr"
            placeholder="请输入医生姓名"
            size="small"
            clearable
          />
        </div>
        <div class="filter-item">
          <span class="filter-label">签约人</span>
          <el-select
            v-model="searchForm.workNumber"
            placeholder="请选择签约人"
            size="small"
            clearable
            filterable
            remote
            :remote-method="remoteSearchEmployee"
            :loading="employeeLoading"
          >
            <el-option v-for="item in filteredEmployeeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-label">首次坐诊日期</span>
          <el-date-picker
            v-model="searchForm.date"
            style="width: 260px"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            value-format="yyyy-MM-dd"
          />
        </div>
        <div class="filter-item">
          <span class="filter-label">销售星级</span>
          <el-select
            v-model="searchForm.salesStar"
            placeholder="请选择销售星级"
            size="small"
            clearable
            multiple
            collapse-tags
            collapse-tags-tooltip
          >
            <el-option label="五星" value="5"></el-option>
            <el-option label="四星" value="4"></el-option>
            <el-option label="三星" value="3"></el-option>
            <el-option label="二星" value="2"></el-option>
            <el-option label="一星" value="1"></el-option>
          </el-select>
        </div>
        <div class="filter-actions">
          <el-button type="primary" @click="getTableData">查询</el-button>
          <el-button @click="resetHandle">重置</el-button>
        </div>
      </div>
    </div>

    <!-- 表格区域 -->
    <div class="table-section" ref="tableSection">
      <CustomTable
        :tableData="tableData"
        :column="tableColumns"
        border
        class="signed-table"
        :header-cell-style="headerCellStyle"
        :max-height="tableMaxHeight"
      >
        <template slot="nameCell" slot-scope="{ row }">
          <el-tag
            type="info"
            effect="plain"
            size="small"
            style="cursor: pointer;"
            @click="showOrHideModalHandle('showClueDetail', row)"
          >{{ row.doctorName }}</el-tag>
        </template>
        <template slot="starCell" slot-scope="{ row }">
          <CustomStarText :saleStar="row.saleStar" :avgStar="row.avgStar" />
        </template>
      </CustomTable>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="pageInfo.total"
          :page-size="pageInfo.pageSize"
          :current-page.sync="pageInfo.pageNum"
          @current-change="changePageHandle"
        ></el-pagination>
      </div>
    </div>
    <!-- 线索详情 -->
    <CustomModal
      v-model="modalInfo.showClueDetail"
      title="线索详情"
      width="800px"
      :showSubmitBtn="false"
      :showCancelBtn="true"
      cancelBtnText="关闭"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showClueDetail')"
    >
      <ClueDetail
        v-if="modalInfo.showClueDetail"
        ref="clueDetailRef"
        :instanceId="currentClueInfo.doctorStageId || ''"
        :doctorId="currentClueInfo.doctorId || ''"
        @confirmHandle="showOrHideModalHandle('showClueDetail')"
      />
    </CustomModal>
  </div>
</template>
 
<script>
  import request from '@/utils/request'
  import utils from '@/views/DoctorVisitLTC/utils/index'
  export default {
    name: 'SignedList',
    data() {
      return {
        loading: false, // 加载状态
        // 表格最大高度
        tableMaxHeight: 500,
        // 搜索表单
        searchForm: {
          queryStr: '', // 医生电话/姓名
          workNumber: '',
          date: [], // 首次坐诊日期
          salesStar: [] // 改为数组类型，支持多选
        },
        employeeOptions: [],
        employeeLoading: false, // 员工搜索加载状态
        searchKeyword: '', // 搜索关键字
        // 表格数据
        tableData: [],
        // 表格列配置
        tableColumns: [
          { prop: 'index', label: '序号', minWidth: '60', align: 'center' },
          { prop: 'doctorName', label: '医生姓名', minWidth: '120', align: 'left', slotName: 'nameCell' },
          { prop: 'star', label: '星级', minWidth: '100', align: 'center', slotName: 'starCell' },
          { prop: 'monthSale', label: '月销售额', minWidth: '120', align: 'center' },
          { prop: 'avgVisitNum', label: '次均门诊量', minWidth: '120', align: 'center' },
          { prop: 'auditerNameText', label: '引进到馆审批确定人', minWidth: '160', align: 'center' },
          { prop: 'signDate', label: '签约日期', minWidth: '140', align: 'center' },
          { prop: 'firstDate', label: '首次坐诊日期', minWidth: '140', align: 'center' },
          { prop: 'followerWorkName', label: '签约人', minWidth: '100', align: 'center' },
          { prop: 'groupName', label: '团队', minWidth: '100', align: 'center' },
          // { prop: 'signPeriod', label: '签约周期', minWidth: '100', align: 'center' }
        ],
        // 分页
        pageInfo: {
          pageNum: 1,
          pageSize: 20,
          total: 0
        },
        currentClueInfo: {},
        modalInfo: {
          showClueDetail: false
        }
      }
    },
    computed: {
      // 过滤后的员工列表
      filteredEmployeeOptions() {
        if (!this.searchKeyword) {
          return []
        }
        // 根据搜索关键字过滤员工列表
        const keyword = this.searchKeyword.toLowerCase()
        return this.employeeOptions.filter(item => 
          item.label.toString().toLowerCase().includes(keyword) || 
          item.value.toString().toLowerCase().includes(keyword)
        )
      }
    },
    methods: {
      // 计算表格最大高度
      calculateTableHeight() {
        this.$nextTick(() => {
          const viewportHeight = window.innerHeight
          const pageHeader = document.querySelector('.page-header')
          const filterSection = document.querySelector('.filter-section')
          const tableSection = this.$refs.tableSection
          
          if (pageHeader && filterSection && tableSection) {
            // 获取各部分高度
            const headerHeight = pageHeader.offsetHeight
            const filterHeight = filterSection.offsetHeight
            
            // 计算表格区域可用高度（减去分页、padding、margin等）
            // 分页高度约 44px，table-section padding 32px（16*2），margin 16px
            const reservedHeight = headerHeight + filterHeight + 44 + 32 + 16 + 18
            
            // 设置表格最大高度
            this.tableMaxHeight = viewportHeight - reservedHeight
          }
        })
      },
      async getEmployeeOptions() {
        const params = {}
        try {
          const res = await request.get('/cluepool/pc/user/all', params, '')
          if(res.code === 200) {
            this.employeeOptions = (res.data || []).map(item => ({
              label: item.nickName,
              value: item.workNumber
            }))
          } else {
            this.$message.error(res.message)
          }
        } catch (error) {
          console.log('请求员工列表数据请求失败', error)
        }
      },
      // 远程搜索员工
      remoteSearchEmployee(query) {
        if (query !== '') {
          this.employeeLoading = true
          this.searchKeyword = query
          // 模拟远程搜索延迟，优化用户体验
          setTimeout(() => {
            this.employeeLoading = false
          }, 200)
        } else {
          this.searchKeyword = ''
          this.employeeLoading = false
        }
      },
      // 表头样式
      headerCellStyle() {
        return { background: '#F7F8F9', color: '#667182', fontWeight: 500 }
      },
      // 重置搜索
      resetHandle() {
        this.searchForm = {
          queryStr: '', // 医生电话/姓名
          workNumber: '',
          date: '', // 首次坐诊日期
          salesStar: [] // 改为数组类型，支持多选
        }
        this.getTableData()
      },
      // 查询
      async getTableData() {
        const date = this.searchForm.date || []
        const salesStar = this.searchForm.salesStar || []
        const params = {
          pageNum: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize,
          queryStr: this.searchForm.queryStr,
          workNumber: this.searchForm.workNumber,
          firstDateBegin: date[0] || '',
          firstDateEnd: date[1] || '',
          queryAll: true,
          ...salesStar.length > 0 && {
            saleStarList: salesStar
          }
        }
        try {
          this.loading = true
          const res = await request.post('/cluepool/pc/clue/signedList', params, '')
          if (res.code === 200) {
            const data = res.data || {}
            this.tableData = (data.data || []).map((item, index) => ({
              ...item,
              index: index + 1,
              firstDate: item.firstDate ? new Date(item.firstDate).Format('yyyy-MM-dd') : '',
              createTime: item.createTime ? new Date(item.createTime).Format('yyyy-MM-dd') : '',
              signDate: item.signTime ? new Date(item.signTime).Format('yyyy-MM-dd') : '',
              auditerNameText: utils.getDataType(item.auditerName) === 'array' ? item.auditerName.join('、') : (item.auditerName || '')
            }))
            this.pageInfo.total = data.totalElements
          } else {
            this.$message.error(res.message)
          }
        } catch (error) {
          console.error('获取数据失败：', error)
        } finally {
          this.loading = false
        }
      },
      // 分页变化
      changePageHandle(page) {
        this.pageInfo.pageNum = page
        this.getTableData()
      },
      showOrHideModalHandle(modalName, itemInfo) {
        this.modalInfo[modalName] = !this.modalInfo[modalName]
        this.currentClueInfo = itemInfo || {}
      },
    },
    components: {
      CustomTable: () => import('@/components/CustomTable.vue'),
      CustomStarText: () => import('@/views/DoctorVisitLTC/components/customStarText/CustomStarText.vue'),
      CustomModal: () => import('@/views/DoctorVisitLTC/components/customModal/Custom_Modal.vue'),
      ClueDetail: () => import('../workbench/components/modal/ClueDetail.vue')
    },
    mounted() {
      // 初始化时计算表格高度
      this.calculateTableHeight()
      this.getTableData()
      this.getEmployeeOptions()
    }
  }
 
</script>

<style scoped lang='less'>
.signed-list-page {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #F5F5F5;

  .page-header {
    background: #FFFFFF;
    border-bottom: 1px solid #E0E0E0;

    .tab {
      padding: 0 16px;
      height: 48px;
      line-height: 48px;
      background: #FFFFFF;
      font-weight: 600;
      font-size: 16px;
      color: #1F2329;
    }
  }

  // 筛选区域
  .filter-section {
    background: #FFFFFF;
    padding: 16px;
    border-radius: 4px;

    .filter-form {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap; // 允许换行

      .filter-item {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        white-space: nowrap;
        min-width: 200px; // 最小宽度，确保在小屏幕上合理显示
        flex: 0 1 auto; // 允许收缩但不放大

        .filter-label {
          font-size: 13px;
          color: #667182;
          flex-shrink: 0;
        }

        /deep/ .el-input,
        /deep/ .el-select,
        /deep/ .el-date-editor {
          width: 180px;
          
          // 在小屏幕上缩小输入框宽度
          @media (max-width: 1400px) {
            width: 160px;
          }
          
          @media (max-width: 1200px) {
            width: 140px;
          }
        }
      }

      .filter-actions {
        display: inline-flex;
        gap: 8px;
        flex-shrink: 0;
        
        // 在小屏幕上按钮靠左对齐
        @media (max-width: 1200px) {
          margin-left: 0;
        }
      }
    }
  }

  // 表格区域
  .table-section {
    background: #FFFFFF;
    padding: 0 16px 6px;

    .signed-table {
      /deep/ .el-table {
        font-size: 13px;
        color: #1F2329;
        border-color: #EBEAEE;

        &::before,
        &::after {
          background-color: #EBEAEE;
        }

        th {
          padding: 0 !important;
          height: 40px;
        }

        td {
          padding: 0 !important;
          height: 44px;
        }

        .cell {
          line-height: 20px;
        }
      }

      /deep/ .el-tag--plain.el-tag--info {
        background-color: #F7F8F9;
        border-color: #EBEAEE;
        color: #667182;
        height: 24px;
        line-height: 22px;
        padding: 0 10px;
        border-radius: 12px;
        font-size: 12px;
        cursor: pointer;

        &:hover {
          border-color: #1890FF;
          color: #1890FF;
        }
      }
    }

    .pagination-wrap {
      display: flex;
      justify-content: flex-end;
      margin-top: 16px;
    }
  }
}
</style>